"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cnbuilder = require("cnbuilder");
var _ProgressIndicatorModule = _interopRequireDefault(require("./ProgressIndicator.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
/**
 * A component that is only used internally by other Pulse components to centralize UI and functionality
 * for a progress indicator set by its parent.
 */const ProgressIndicator = _ref => {
  let {
    classNameRoot,
    classNameProgress,
    testAttrRoot,
    testAttrProgress,
    totalSteps,
    currentStep
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _cnbuilder.cnb)(_ProgressIndicatorModule.default.root, classNameRoot),
    "data-test": testAttrRoot,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)(_ProgressIndicatorModule.default.progress, classNameProgress),
      style: {
        width: "".concat(Math.ceil(currentStep / totalSteps * 100), "%"),
        borderWidth: currentStep <= 0 ? '0' : '1px'
      },
      "data-test": testAttrProgress
    })
  });
};
ProgressIndicator.defaultProps = {
  testAttrRoot: 'progress-indicator-root',
  testAttrProgress: 'progress-indicator-progress',
  currentStep: 0
};
var _default = exports.default = ProgressIndicator;